import { MediaType } from '@/contexts/chat/scripts/hooks/useQuickVO/types';
import { useChatContext } from '@/contexts/chat/context';

const DrawSpeak = ({ member, callUserInfo, callUserStream }: any) => {
  const { chatMediaQuickVO } = useChatContext();
  const { drawSpectrum, clearRequestAnimationFrame } = chatMediaQuickVO;

  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const frameId = `${member.userId}-${MediaType.MICROPHONECAMERA_AUDIO}`;
    if (canvasRef.current && callUserInfo?.callActionMap.microphoneCamera_audio) {
      drawSpectrum(
        member.userId,
        MediaType.MICROPHONECAMERA_AUDIO,
        canvasRef.current,
        frameId
      );
    }
    return () => clearRequestAnimationFrame(frameId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    drawSpectrum,
    member.userId,
    canvasRef.current,
    callUserInfo?.callActionMap.microphoneCamera_audio,
    callUserStream?.updateStreams,
  ]);

  return <canvas width={17} height={12} ref={canvasRef}></canvas>;
};

export default DrawSpeak;
